<template>
  <div>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="专场名称">
        <el-input
          size="small"
          v-model="formInline.SpecialSessionName"
          placeholder="输入专场名称"
        ></el-input>
      </el-form-item>

      <el-form-item label="状态">
        <el-select
          v-model="formInline.CommodityState"
          @change="resetData"
          placeholder="请选择状态"
        >
          <el-option label="全部" value="0"></el-option>
          <el-option label="已上架" value="1"></el-option>
          <el-option label="已下架" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >查询</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleEdit"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;margin-bottom:40px"
      height="64vh"
    >
      <el-table-column
        prop="SpecialSessionPicURL"
        label="图片"
        min-width="100px"
      >
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.SpecialSessionPicURL"
            style="width: 100px; height: 100px"
            :src="SpecialPic + scope.row.SpecialSessionPicURL"
            fit="scale-down"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="SpecialSessionName"
        label="专场名称"
      ></el-table-column>

      <el-table-column prop="StartTime" label="开始时间"></el-table-column>

      <el-table-column prop="EndTime" label="截止时间"></el-table-column>

      <el-table-column prop="CreatTime" label="创建时间"></el-table-column>

      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleUp(scope.row)">{{
            scope.row.SpecialSessionState == "已上架"
              ? "下架"
              : "上架"
          }}</el-button>
          <el-button size="mini" type="text" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="deleteFn(scope.row)"
            v-if="
              scope.row.SpecialSessionState == '已下架' 
            "
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <mPage
      :page="pageparm.page"
      :total="pageparm.total"
      @change="changePage"
    ></mPage>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="1000px"
      @close="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        ref="editForm"
        class="flex flex_wrap"
      >
        <div style="width: 900px">
          <el-form-item
            label="专场名称"
            prop="SpecialSessionName"
            :rules="[
              { required: true, message: '请输入专场名称', trigger: 'blur' },
            ]"
          >
            <el-input
              size="small"
              v-model="editForm.SpecialSessionName"
              auto-complete="off"
              placeholder="请输入专场名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="开始时间"
            prop="StartTime"
            :rules="[
              { required: true, message: '选择开始时间', trigger: 'blur' },
            ]"
          >
            <el-date-picker
              v-model="editForm.StartTime"
              type="datetime"
              placeholder="选择开始时间"
              @change="
                (v) => {
                  changeTime(v, 'StartTime');
                }
              "
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="截止时间"
            prop="EndTime"
            :rules="[
              { required: true, message: '选择截止时间', trigger: 'blur' },
            ]"
          >
            <el-date-picker
              v-model="editForm.EndTime"
              type="datetime"
              placeholder="选择截止时间"
              @change="
                (v) => {
                  changeTime(v, 'EndTime');
                }
              "
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="专场图片">
            <mupload
              :fileList="fileList"
              FilePath="images/SpecialPic"
              uploadName="upload"
              :canUpload="true"
              @handleUpload="handleUpload"
              @handleRemove="handleRemoveFile"
            ></mupload>
          </el-form-item>
          <el-table
            size="small"
            :data="selectedGoods"
            highlight-current-row
            v-loading="loading"
            border
            element-loading-text="拼命加载中"
            style="width: 100%"
            height="64vh"
          >
            <el-table-column
              prop="CommodityName"
              label="名称"
            ></el-table-column>
            <el-table-column
              prop="CommodityNature"
              label="类型"
            ></el-table-column>
            <el-table-column
              prop="CommodityPrice"
              label="价格/起拍价"
            ></el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click="deleteGoodsFn(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-button class="plus1" @click="showSearchDialog">
            <i class="el-icon-plus"></i
          ></el-button>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑界面 -->
    <el-dialog
      title="选择商品"
      :visible.sync="searchVisible"
      width="1000px"
      @close="closeSearchDialog"
    >
      <div style="width: 900px">
        <div class="flex flex_center marginBottom">
          <div>关键词</div>
          <el-input class="w80" v-model="searchName"></el-input
          ><el-button type="primary" @click="getGoodsList">查询</el-button>
        </div>
        <el-table
          size="small"
          :data="goodsList"
          highlight-current-row
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          v-loading="loading"
          :row-key="getRowKeys"
          border
          element-loading-text="拼命加载中"
          style="width: 100%"
          height="64vh"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="CommodityName" label="名称"></el-table-column>
          <el-table-column
            prop="CommodityNature"
            label="类型"
          ></el-table-column>
          <el-table-column
            prop="CommodityPrice"
            label="价格/起拍价"
          ></el-table-column>
        </el-table>
        <el-icon type="add"></el-icon>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeSearchDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="choosedFn('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
let editForm = {
  EndTime: "",
  HaveSpecialSessionPic: "",
  IDX: "",
  SpecialSessionGUID: "",
  SpecialSessionName: "",
  SpecialSessionPicURL: "",
  SpecialSessionState: "",
  StartTime: "",
};

import mPage from "../../components/mPage";
// import dialogFom from "./dialogFom"
import mupload from "@/components/upload.vue";
let flag = true;
export default {
  components: { mupload, mPage },
  data() {
    return {
      delFileList: [],
      goodsData: [],
      fileList: [],
      loading: false, //是显示加载
      SpecialPic: this.$SpecialPic,
      personInfo: {},
      // 分页参数
      pageparm: {
        page: 1,
        limit: 10,
        total: 10,
      },
      searchName: "",
      listData: [],
      goodsList: [],
      formInline: {
        page: 1,
        limit: 10,
        SpecialSessionName: "",
        CommodityState: "0",
      },
      editForm,
      editFormVisible: false,
      dialogImageUrl: "",
      dialogVisible: false,
      title: "新增",
      searchVisible: false,
      multipleSelection: [],
      selectedGoods: [],
      deleteGoods: [],
    };
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.personInfo = JSON.parse(this.$util.getStore("personInfo"));
  },
  mounted() {
    this.search();
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getRowKeys(row) {
      //唯一值，一般都未id
      return row.CommodityGUID;
    },
    // 删除
    deleteFn(row) {
      this.$confirm('是否要删除"' + row.SpecialSessionName + '"', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.delGoodsFn(row.SpecialSessionGUID);
        })
        .catch(() => {});
    },

    delGoodsFn(SpecialSessionGUID) {
      let data = {
        SpecialSessionGUID,
      };
      this.$loading();
      this.$api
        .ExSqlFn(
          "ShopWebApp\\DeleteSpecialSession_1_0_1&DBC=w_m",
          JSON.stringify(data)
        )
        .then((res) => {
          this.$loading().close();
          let result = res.data;
          if (result.OK != "True") {
            this.$message(result.Message);
          } else if (result.Tag.length <= 0) {
            this.$message("删除失败");
          } else {
            this.$message("删除成功");
            this.search();
          }
        });
    },
    handleUp(data) {
      console.log(data, 382);
      let state =
        data.SpecialSessionState == "已上架" 
          ? "下架"
          : "上架";
      this.$confirm("确定要" + state + "吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleToUp(data.SpecialSessionGUID, state);
        })
        .catch(() => {});
    },
    handleToUp(SpecialSessionGUID, state) {
      let data1 = {
        SpecialSessionGUID,
        SpecialSessionState:'已'+ state,
      };
      this.$loading();
      this.$api
        .ExSqlFn("ShopWebApp\\UpdateSpecialSessionState_1_0_1&&DBC=w_m", data1)
        .then((res) => {
          this.$loading().close();
          let result = res.data;
          if (result.OK != "True") {
            this.$message(result.Message);
          } else {
            this.search();
          }
        });
    },
    deleteGoodsFn(i, row) {
      let { selectedGoods, deleteGoods, editForm } = this;
      console.log(row, 433, editForm);
      if (row.SpecialSessionGUID != "") {
        deleteGoods.push(row);
      }
      selectedGoods.splice(i, 1);
      console.log(selectedGoods, 440);
      this.deleteGoods = deleteGoods;
      this.selectedGoods = selectedGoods;
    },

    delGoods(SpecialSessionGUID, transactionName, submitaData) {
      let sqlCmdName = "ShopWebApp\\DeleteSpecialSessionCommoditys_1_0_1";
      let data = [
        {
          SpecialSessionGUID: SpecialSessionGUID,
        },
      ];
      this.$api
        .ExSqlFn(sqlCmdName + "&DBC=w_m", JSON.stringify(data))
        .then((res) => {
          let result = res.data;
          if (result.OK != "True") {
            this.$message(result.Message);
          } else if (result.Tag.length <= 0) {
            this.$message("删除失败");
          } else {
            this.releaseSpecial(transactionName, submitaData);
          }
        });
    },
    changeTime(e, key) {
      console.log(e, 1275);
      // editForm.atSellSwitch,editForm.StartTime
      console.log(e, 330);
    },
    closeSearchDialog() {
      console.log(this.selectedGoods, this.editForm, 467);
      this.searchVisible = false;
      this.editFormVisible = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    choosedFn() {
      if (this.multipleSelection.length > 0) {
        this.selectedGoods = this.multipleSelection;
        this.closeSearchDialog();
        return;
      }

      this.$message("请选择商品");
      console.log(this.multipleSelection, 487);
    },
    showSearchDialog() {
      this.searchVisible = true;
      this.editFormVisible = false;
      this.multipleSelection = [];
    },
    getGoodsList() {
      if (flag) {
        flag = false;
        let { personInfo, searchName, multipleSelection, selectedGoods } = this;
        let data = {
          ShopGUID: personInfo.ShopGUID,
          CompanyGUID: personInfo.CompanyGUID,
          CommodityName: searchName,
        };
        this.$loading();
        this.$api
          .QueryDataFn(
            "ShopWebApp\\GetSpecialSessionAllCommoditys_1_0_1&DBC=r_m",
            data
          )
          .then((res) => {
            this.$loading().close();
            let data = res.data;
            console.log(data, 504);
            flag = true;
            if (data.OK == "True" && data.Tag && data.Tag.length > 0) {
              let { Table } = data.Tag[0];
              console.log(this.selectedGoods, 519);
              Table.forEach((item) =>
                selectedGoods.forEach((node) => {
                  if (item.CommodityGUID == node.CommodityGUID) {
                    multipleSelection.push(item);
                    item.Selected = true;
                  }
                })
              );
              this.multipleSelection = multipleSelection;
              this.goodsList = Table;
              console.log(this.goodsList);
              this.$nextTick(() => {
                this.goodsList.forEach((item) => {
                  if (item.Selected === true) {
                    console.log(item, 5333);
                    this.$refs.multipleTable.toggleRowSelection(item, true);
                  }
                });
              });
            } else {
              this.goodsList = [];
            }
          });
      }
    },
    handleUpload(e) {
      console.log(e, 444);
      this.fileList = [e];
      this.editForm.SpecialSessionPicURL = e.name;
    },
    handleRemoveFile(e) {
      let { SpecialSessionGUID, SpecialSessionPicName } = this.editForm;
      console.log(this.editForm, 30444, SpecialSessionGUID == "");
      this.fileList = [];
      this.editForm.SpecialSessionPicURL = "";
      this.editForm.SpecialSessionPicName = "";
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //显示编辑界面
    handleEdit: function (row) {
      console.log(row, 3788);
      this.editFormVisible = true;
      this.goodsList = [];
      if (row.SpecialSessionCommoditys) {
        if (row.SpecialSessionPicURL != "") {
          let url = this.SpecialPic + row.SpecialSessionPicURL,
            obj = {
              name: row.SpecialSessionPicURL,
              url,
            };
          this.fileList = [obj];
        } else {
          this.fileList = [];
        }
        this.editForm = row;
        this.selectedGoods = row.SpecialSessionCommoditys;
      } else {
        this.editForm = editForm;
        this.selectedGoods = [];
        this.fileList = [];
      }
      this.deleteGoods = [];
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },

    resetData() {
      this.listData = [];
      this.pageparm = {
        page: 1,
        limit: 10,
        total: 10,
      };
    },
    search() {
      let { personInfo, pageparm, formInline } = this,
        data = {
          ShopGUID: personInfo.ShopGUID,
          CompanyGUID:
            parseFloat(personInfo.UserType) < 3 ? personInfo.CompanyGUID : "",
          CommodityState:
            formInline.CommodityState == 1
              ? "已上架"
              : formInline.CommodityState == 2
              ? "已下架"
              : "全部",
          SpecialSessionName: formInline.SpecialSessionName,
          PageNumber: pageparm.page-1,
        };
      console.log(55555555555);
      this.$loading();
      this.$api
        .QueryDataFn(
          "Web\\GetSpecialSessionList_1_0_1,Web\\GetSpecialSessionCommoditys_1_0_1&DBC=w_m",
          //   "ShopWebApp\\GetSpecialSessionList_1_0_1,ShopWebApp\\GetSpecialSessionCommoditys_1_0_1",
          data
        )
        .then((res) => {
          this.$loading().close();
          let data = res.data;
          if (data.OK == "True" && data.Tag && data.Tag.length > 0) {
            this.listData = data.Tag[0].Table;
            this.canNext = true;
          } else {
            this.listData = [];
            this.canNext = false;
          }
        });
    },
    changePage(e, i) {
      let { total, page } = this.pageparm;
      if (e == 1) {
        page--;
        this.canNext = page < 1 ? false : true;
      } else {
        if (this.canNext) {
          page++;
        } else {
          total = page;
        }
      }
      this.pageparm.page = page;
      this.pageparm.total = total;
      if (this.canNext) {
        this.search();
      }
    },
    submitForm() {
      console.log(this.editForm);
      let nowTime = new Date();
      let { EndTime, StartTime, SpecialSessionName } = this.editForm;
      if (new Date(EndTime).getTime() - new Date(StartTime).getTime() <= 0) {
        this.$message("截止时间需在开始时间之后");
        return;
      }
      if (new Date(EndTime).getTime() - nowTime.getTime() <= 0) {
        this.$message("截止时间需在当前时间之后");
        return;
      }
      if (SpecialSessionName == "") {
        this.$message("专场名称不能为空");
        return;
      }

      if (this.selectedGoods.length <= 2) {
        this.$message("专场商品不能小于3个");
        return;
      }

      this.judgeAddorEdit(StartTime, EndTime);
    },

    judgeAddorEdit(startTime, endTime) {
      if (flag) {
        flag = false;
        this.$loading();
        let SpecialSessionGUID = this.editForm.SpecialSessionGUID || "";
        if (SpecialSessionGUID != "") {
          this.setSubmitData(startTime, endTime, SpecialSessionGUID, "");
        } else {
          this.$api.returnGuid().then((guid) => {
            this.setSubmitData(startTime, endTime, SpecialSessionGUID, guid);
          });
        }
      }
    },

    setSubmitData(
      startTime,
      endTime,
      SpecialSessionGUID,
      newSpecialSessionGUID
    ) {
      let { personInfo, selectedGoods, editForm, deleteGoods } = this;
      let transactionName = "";
      let Parameter2 = [];
      for (let i in selectedGoods) {
        let obj = {
          SpecialSessionGUID: SpecialSessionGUID || newSpecialSessionGUID,
          CommodityGUID: selectedGoods[i].CommodityGUID,
        };
        Parameter2.push(obj);
      }
      let data = [
        {
          SqlCmdName: "ShopWebApp\\UpdateSpecialSessionInfo_1_0_1",
          DBC: "w_m",
          Parameter: "",
        },
        {
          SqlCmdName: "ShopWebApp\\InsertSpecialSessionCommoditys_1_0_1",
          DBC: "w_m",
          Parameter: JSON.stringify(Parameter2),
        },
      ];
      let Parameter1 = [
        {
          SpecialSessionGUID: SpecialSessionGUID || newSpecialSessionGUID,
          SpecialSessionName: editForm.SpecialSessionName || "",
          StartTime: startTime,
          EndTime: endTime,
          SpecialSessionPicURL: editForm.SpecialSessionPicURL || "",
          ShopGUID: personInfo.ShopGUID,
          CompanyGUID: personInfo.CompanyGUID,
        },
      ];
      data[0].Parameter = JSON.stringify(Parameter1);
      if (SpecialSessionGUID == "") {
        transactionName = "发布专场";
        this.releaseSpecial(transactionName, data);
      } else {
        transactionName = "修改专场";
        this.delGoods(SpecialSessionGUID, transactionName, data);
      }
      console.log(data);
    },
    releaseSpecial: function (transactionName, submitaData) {
      this.$loading();
      this.$api
        .exsqlDistributedUrl(transactionName, JSON.stringify(submitaData))
        .then((res) => {
          let result = res.data;
          console.log(result, 16999);
          flag = true;
          this.$loading().close();
          if (result.OK != "True") {
            this.$message(result.Message);
          } else {
            this.search();
            this.editFormVisible = false;
          }
        });
    },
  },
};
</script>

<style scoped>
.plus1 {
  border: 1px solid #eee;
  padding: 20rpx !important;
  display: inline-block;
  margin-top: 10px;
}
.user-search {
  margin-top: 20px;
}

.commodityPicUR {
  width: 60px;
  height: 100px;
}

.userRole {
  width: 100%;
}

.gray {
  color: gray;
}

.arrow {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #a0cfff;
  color: #fff;
  background-color: #a0cfff;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 12px 20px;
  font-size: 14px;
  border-radius: 4px;
  margin: 0 20px;
}

.arrow1 {
  background-color: #409eff;
  border-color: #409eff;
}
.w80 {
  width: 80%;
  margin: 0 10px;
}
.scrollBox {
  width: 300px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
  position: relative;
  height: 350px;
  padding: 0 0 0 20px;
  font-size: 14px;
}

.rightContent {
  width: auto;
  min-width: 320px;
}

.scrollView {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  height: 312px;
  overflow: scroll;
}

.scrollView .el-radio {
  height: 28px;
  line-height: 28px;
}

.goodsUl {
  height: 300px;
  overflow-y: scroll;
  margin-top: 20px;
  border: 1px solid rgba(0, 0, 0, 0.3);
}

.goodsLi {
  padding: 10px;
  height: 210px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}

.goodsLi:last-child {
  border-bottom: 0;
}

.activeGoods {
  box-shadow: 0px 0px 5px 0 rgba(0, 0, 0, 0.3) inset;
}

.activeGoods .title {
  color: #f65353;
}

.goodsImg {
  width: 200px;
  height: 200px;
  margin: 0 20px;
}

.CommodityNature {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  padding: 0 16px;
  border-radius: 20px;
  -webkit-border-radius: 20px;
  font-size: 12px;
  color: #f9f9f9;
  background: #f65353;
  margin-right: 50px;
}
</style>
<style>
.editor-upload1 {
  width: 700px;
  height: 350px;
  text-align: center;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
}

.editor-upload1 .el-upload--text {
  width: 700px;
  height: 350px;
  line-height: 350px;
}

.upload1-avatar {
  width: 700px;
  height: 350px;
  position: relative;
}

.absolute {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9;
  font-size: 36px;
}

.editor-upload1 .el-upload--picture-card i {
  height: 30px;
}
</style>





// WEBPACK FOOTER //
// src/views/shop/special.vue